export default class AddToBagToastMessage {
    static getAddToCartSuccess(localizedInformationOrTranslations, urls) {
        const { addToShoppingCartSuccessHeadline, addToShoppingCartName } = this.getToastTranslations(localizedInformationOrTranslations);
        if ('urls' in localizedInformationOrTranslations) {
            return {
                label: addToShoppingCartSuccessHeadline,
                actionHref: localizedInformationOrTranslations.urls.shoppingCartLink,
                actionLabel: addToShoppingCartName
            };
        }
        else if (urls) {
            return {
                label: addToShoppingCartSuccessHeadline,
                actionHref: urls.shoppingCartLink,
                actionLabel: addToShoppingCartName
            };
        }
        throw new Error("URLs must either be provided through the 'urls' parameter or by using the ILocalizedInformation type for the 'localizedInformationOrTranslations' parameter.");
    }
    static getAddToCartFailure(localizedInformationOrTranslations, urls) {
        const { addToShoppingCartFailureHeadline, addToShoppingCartFailureLink } = this.getToastTranslations(localizedInformationOrTranslations);
        if ('urls' in localizedInformationOrTranslations) {
            return {
                label: addToShoppingCartFailureHeadline,
                actionHref: localizedInformationOrTranslations.urls.shoppingCartLink,
                actionLabel: addToShoppingCartFailureLink
            };
        }
        else if (urls) {
            return {
                label: addToShoppingCartFailureHeadline,
                actionHref: urls.shoppingCartLink,
                actionLabel: addToShoppingCartFailureLink
            };
        }
        throw new Error("URLs must either be provided through the 'urls' parameter or by using the ILocalizedInformation type for the 'localizedInformationOrTranslations' parameter.");
    }
    static getAddToCartFail(localizedInformationOrTranslations, urls) {
        const { addToShoppingBagAndListErrorMessage, addToShoppingListName } = this.getToastTranslations(localizedInformationOrTranslations);
        if ('urls' in localizedInformationOrTranslations) {
            return {
                label: addToShoppingBagAndListErrorMessage,
                actionHref: localizedInformationOrTranslations.urls.shoppingListLink,
                actionLabel: addToShoppingListName
            };
        }
        else if (urls) {
            return {
                label: addToShoppingBagAndListErrorMessage,
                actionHref: urls.shoppingListLink,
                actionLabel: addToShoppingListName
            };
        }
        throw new Error("URLs must either be provided through the 'urls' parameter or by using the ILocalizedInformation type for the 'localizedInformationOrTranslations' parameter.");
    }
    static getToastTranslations(localizedInformationOrTranslations) {
        if ('translations' in localizedInformationOrTranslations) {
            return localizedInformationOrTranslations.translations;
        }
        return localizedInformationOrTranslations;
    }
}
//# sourceMappingURL=AddToBagToastMessage.js.map